export const CPF_TRAINING_TYPE_MARKER = 'CPF';
